import React, { useEffect } from "react";

import "./Arena.css";

import IgniteNavbar from "../../layout/IgniteNavbar";
import IgniteHeader from "../../layout/IgniteHeader";

import ArenaHero from "./Components/ArenaHero";
import PracticeModes from "./Components/PracticeModes";
import LeaderboardPreview from "./Components/LeaderboardPreview";
import ContinueTraining from "./Components/ContinueTraining";

import CurrentStreak from "./Components/CurrentStreak";

const Arena = () => {
     // Hide website footer
      useEffect(() => {
           window.scrollTo({
             top: 0,
             behavior: "smooth",
           });
         }, []);
      useEffect(() => {
        const navbar = document.querySelector("header, .navbar");
        const footer = document.querySelector("footer");
      
       
        if (navbar) navbar.style.display = "none";
        if (footer) footer.style.display = "none";
      
        return () => {
          // 🔥 மீண்டும் restore
          if (navbar) navbar.style.display = "";
          if (footer) footer.style.display = "";
        };
      }, []);

    return (

        <div className="ignite-arena">

            <IgniteNavbar />

            <main className="ignite-arena-main">

                <IgniteHeader

                    title="Arena"

                    subtitle="Practice. Improve. Climb every leaderboard."

                />

                {/* ================= Hero ================= */}

                <ArenaHero />

                {/* ================= Practice Modes ================= */}

                <div className="arena-section">

                    <PracticeModes />

                </div>

                {/* ================= Individual Leaderboards ================= */}

                <div className="arena-section">

                    <LeaderboardPreview />

                </div>

                {/* ================= Resume Training + Current Streak ================= */}

                <div className="arena-row">

                    <ContinueTraining />

                    <CurrentStreak />

                </div>

            </main>

        </div>

    );

};

export default Arena;
